module.exports = __webpack_public_path__ + "img/enproceso.fbf39d8b.png";